export const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.info(error);
    copyToClipboardOld(text);
  }
};

// A hack for old android to get clipboard copy feature ready
const copyToClipboardOld = (textToCopy: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = textToCopy;

  // Move the textarea outside the viewport to make it invisible
  textarea.style.position = 'absolute';
  textarea.style.left = '-99999999px';

  document.body.prepend(textarea);

  // highlight the content of the textarea element
  textarea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.log(err);
  } finally {
    textarea.remove();
  }
};

export const shareThroughtNavigator = async (link: string, text: string | null) => {
  if ('share' in navigator) {
    try {
      return navigator.share({
        url: link,
        title: text ?? '',
      });
    } catch (error) {
      console.log(new Error(`Couldn't share article link: `, { cause: error }));
    }
  }

  return copyToClipboard(link);
};
